<script setup lang="ts">
import { CholesterolCondition, PersonData } from "@/entities/conditions";
import MedicalFormBuilder from "@/components/medicalConditionForms/MedicalFormBuilder.vue";
import CholesterolReadings from "./CholesterolReadings.vue";
import { parseSchema } from "@/components/medicalConditionForms/schema";
import { useMedicalForm } from "../useMedicalForm";

import cholesterol from "./cholesterol.json";
import { Suggestion } from "@/entities/suggestion";

export interface Props {
    condition: CholesterolCondition,
    personDetails: PersonData,
    subConditionSuggestion?: Suggestion | null
}

const props = defineProps<Props>();

const emit = defineEmits<{
        (on:"update:condition", value: CholesterolCondition): void
    }>();

const { onConditionUpdate, state } = useMedicalForm({
    ...props.condition,
    medications: props.condition.medications || [],
    cholesterolReadings: props.condition.cholesterolReadings || [],
    diagnosis_date: props.condition.diagnosis_date || "",
}, emit);

</script>

<template>
    <MedicalFormBuilder
        :schema="parseSchema(cholesterol)"
        :initial-form="state.condition"
        :diagnosis-date="state.condition.diagnosis_date"
        :person-details="props.personDetails"
        @update:form="onConditionUpdate"
    >
        <template #cholesrtolReadings>
            <CholesterolReadings
                v-model="state.condition.cholesterolReadings"
                :diagnosis-date="state.condition.diagnosis_date"
            />
        </template>
    </MedicalFormBuilder>
</template>

<style>

</style>
